import { Module, VuexModule, Action } from "vuex-module-decorators";
import api from "@/api/stadium_cooperate";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async check(params: any) {
    return api.check(params);
  }
  @Action
  async submit(params: any) {
    return api.submit(params);
  }
}
